import axios from "axios";
import { IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { trackEvent } from "../../tracking/trackEvent";
import {
  airPriceWatchApi,
  DeleteWatchAlertRequest,
} from "@b2bportal/air-price-watch-api";

export const deleteWatch = (
  request: DeleteWatchAlertRequest,
  apiConfig?: IApiConfig
): Promise<unknown> => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await airPriceWatchApi(axios).apiV0AlertWatchDeletePost(
        request
      );
      resolve(res.data);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
};
